import { apiService } from 'core/services/apiService';

interface DailySummary {
  date: string;
  weekday: string;
  trafficTotal: number;
  salesTotal: number;
}

interface WeeklyDailySummariesResponse {
  member: DailySummary[];
}

export const getWeeklyDailySummaries = async (workplaceId: number): Promise<WeeklyDailySummariesResponse> => {
  const response = await apiService.get(`/workplace-daily-summaries/weekly?workplace=${workplaceId}`);
  return response.data;
};